import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'SignUp'*/ 'src/controllers/SignUp/SignUp'),
	loading: Loading,
});
